import { COUNTRY_CODE, WAYBILL_STATUS, APPOINTMENT_STATUE } from '@uip-alpha/business-constants'

export const RegionGroup = {
    MAINLAND: 1, // 大陆
    HONGKONG: 2, // 香港
    MACAO: 3, // 澳门
    TAIWAN: 4, // 台湾
    HMT: 5, // 港澳台
    INTEGER: 6, // 国内
    ABROAD: 7, // 国外
    DirectlyCodeArray: ['A310000000', 'A110000000', 'A500000000', 'A120000000'], // 直辖市code: 上海，北京，重庆，天津
    HMTArray: [COUNTRY_CODE.HK, COUNTRY_CODE.MAC, COUNTRY_CODE.TW], // code: 台湾，香港，澳门
    MACAOArea: ['A000822000', 'A000821000', 'A000823000'], // 澳门半岛，氹仔，路环 没有下级数据
    regionTabs: [
        {
            id: 'chinaArea',
            name: '中国大陆'
        },
        {
            id: 'hmtArea',
            name: '中国港澳台'
        },
        {
            id: 'interArea',
            name: '国际'
        }
    ],
    filterList: [
        'A000001000', // 美国
        // 'A000084000',//越南   备注：已开通美国到越南的到付价
        'A000092000', // 巴基斯坦  新增流向巴基斯坦、菲律宾
        'A000063000', // 菲律宾
        'A000066000', // 泰国
        'A000061000', // 澳大利亚
        'A000007000', // 俄罗斯
        'A000052000', // 墨西哥
        'A000011000', // 加拿大
        'A000095000', // 缅甸
        'A000049000', // 德国
        'A000033000', // 法国
        'A000043000', // 奥地利
        'A000032000', // 比利时
        'A000359000', // 保加利亚
        'A000385000', // 克罗地亚
        'A000045000', // 丹麦
        'A000034000', // 西班牙
        'A000372000', // 爱沙尼亚
        'A000030000', // 希腊
        'A000036000', // 匈牙利
        'A000353000', // 爱尔兰
        'A000039000', // 意大利
        'A000358000', // 芬兰
        'A000371000', // 拉脱维亚
        'A000370000', // 立陶宛
        'A000352000', // 卢森堡
        'A000031000', // 荷兰
        'A000048000', // 波兰
        'A000351000', // 葡萄牙
        'A000420000', // 捷克
        'A000040000', // 罗马尼亚
        'A000044000', // 英国
        'A000421000', // 斯洛伐克
        'A000386000', // 斯洛文尼亚
        'A000046000', // 瑞典
        'A000356000', // 马耳他
        'A000357000', // 塞浦路斯
        'A000055000', // 巴西
        'A000673000', // 文莱
        'A000971000', // 阿拉伯联合酋长国
        'A000164000', // 新西兰
        'A000062000', // 印尼
        'A000091000', // 印度
        'A000855000', // 柬埔寨
        'A000880000', // 孟加拉
        'A000094000', // 斯里兰卡
        'A000056000' // 智利
    ]
}

// 有运单号并且pickupType不等于10的运单状态
export const WaybillStatus = {
    [WAYBILL_STATUS.TO_SENT]: {
        statusTxt: '等待取件',
        timeTxt: '预约上门时间',
        statusIcon: 'progress0'
    },
    [WAYBILL_STATUS.TRANSPORTING]: {
        statusTxt: '运送中',
        timeTxt: '预计送达时间',
        statusIcon: 'progress3'
    },
    [WAYBILL_STATUS.DELIVERING]: {
        statusTxt: '派送中',
        timeTxt: '预计送达时间',
        statusIcon: 'progress5'
    },
    [WAYBILL_STATUS.RECEIVED]: {
        statusTxt: '已签收',
        timeTxt: '签收时间',
        statusIcon: 'progress6'
    },
    [WAYBILL_STATUS.ABOLISHED]: {
        statusTxt: '已作废',
        timeTxt: '作废时间',
        statusIcon: 'progress0'
    },
    [WAYBILL_STATUS.FORWARDED]: {
        statusTxt: '已退回',
        timeTxt: '退回时间',
        statusIcon: 'progress3'
    },
    [WAYBILL_STATUS.RETURNED]: {
        statusTxt: '已转寄',
        timeTxt: '转寄时间',
        statusIcon: 'progress3'
    }
}

// 有运单号并且pickupType不等于10的预约单状态
export const AppointStatus = {
    '0or1': [
        {
            statusTxt: '等待取件',
            timeTxt: '预约上门时间',
            statusIcon: 'progress0'
        },
        {
            statusTxt: '等待上门',
            timeTxt: '预约上门时间',
            statusIcon: 'progress0'
        }
    ], // 如果pickupType=3取第一个，否则取第二个
    [APPOINTMENT_STATUE.PICKED]: {
        statusTxt: '已揽件',
        timeTxt: '揽件时间',
        statusIcon: 'progress1'
    },
    [APPOINTMENT_STATUE.CANCELLED]: {
        statusTxt: '已取消',
        timeTxt: '取消时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.PICKED_ERR]: {
        statusTxt: '已取件',
        timeTxt: '取件时间',
        statusIcon: 'progress1'
    },
    [APPOINTMENT_STATUE.CLOSED]: {
        statusTxt: '已关闭',
        timeTxt: '关闭时间',
        statusIcon: 'progress0'
    }
}

// 同城
export const IntraCityStatus = {
    [APPOINTMENT_STATUE.CANCELLED]: {
        statusTxt: '已取消',
        timeTxt: '取消时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CLOSED]: {
        statusTxt: '已关闭',
        timeTxt: '关闭时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_TO_COLLECT]: {
        statusTxt: '等待上门',
        timeTxt: '',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_TO_PAY]: {
        statusTxt: '待支付',
        timeTxt: '',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_TO_REFUND]: {
        statusTxt: '待退款',
        timeTxt: '',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_REFUNDED]: {
        statusTxt: '已退款',
        timeTxt: '退款时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_CANCELLED]: {
        statusTxt: '已取消',
        timeTxt: '取消时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_DELIVERING]: {
        statusTxt: '运送中',
        timeTxt: '',
        statusIcon: 'progress3'
    },
    [APPOINTMENT_STATUE.CITY_COMPLETED]: {
        statusTxt: '预约完成',
        timeTxt: '完成时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_REJECTED]: {
        statusTxt: '已拒单',
        timeTxt: '拒单时间',
        statusIcon: 'progress0'
    },
    [APPOINTMENT_STATUE.CITY_TO_ORDER]: {
        statusTxt: '可接单',
        timeTxt: '',
        statusIcon: 'progress0'
    }
}



// WEBPACK FOOTER //
// ./src/constant/common.js